import Head from 'next/head';
import { defaultAuthorType, organization } from 'lib/seo/constants';

interface IArticleSchemaProps {
  url: string;
  title: string;
  imageUrl: string;
  description: string;
  date: string;
  modified: string;
  copyright: string;
  authorName?: string;
}

export default function ArticleSchema({
  url,
  title,
  imageUrl,
  description,
  date,
  modified,
  copyright,
  authorName,
}: IArticleSchemaProps) {
  const schemaArticle = {
    '@context': 'http://schema.org',
    '@type': 'Article',
    '@id': url,
    datePublished: date,
    dateModified: modified,
    copyrightHolder: copyright,
    author: {
      '@type': defaultAuthorType,
      name: authorName || organization,
    },
    headline: title,
    description: description,
    image: [imageUrl],
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaArticle) }}
      />
    </Head>
  );
}
